module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-chunk-intro-card02.7e9a8b77.jpg";